const PostLooper = {
    postCount: $('.js-load-more').data('count'),
    postType: $('.js-load-more').data('type'),
    pageNumber: 1,
    isLoading: false,
    totalPosts: 0,

    init() {
        this.bindEvents();
        this.checkForMorePosts();
    },

    bindEvents() {
        $(".js-load-more").on("click", () => {
            if (!this.isLoading) {
                this.loadPosts();
            }
        });
    },

    async loadPosts() {
        this.isLoading = true;
        this.updateButtonState(true);

        try {
            const data = await $.ajax({
                type: "POST",
                dataType: "html",
                url: ajax_posts.ajaxurl,
                data: {
                    post_type: this.postType,
                    pageNumber: ++this.pageNumber,
                    ppp: this.postCount,
                    action: 'more_post_ajax' // See functions.php
                }
            });

            this.handleResponse(data);
        } catch (error) {
            this.handleError(error);
        } finally {
            this.isLoading = false;
            let sliders = window.Slider.getAllSliders();
            let slider = Object.values(sliders)[0];
            if (slider) {
                slider.update();
            }
            this.checkForMorePosts();
        }
    },

    handleResponse(data) {
        if (data.indexOf("No more posts") >= 0) {
            this.hideLoadMoreButton();
            return;
        }

        if (data.length) {
            $("#load-more_wrap").append(data);
            this.updateButtonState(false);
            
            // Count the number of posts loaded
            const loadedPosts = $("#load-more_wrap .post-looper_item").length;
            if (loadedPosts >= this.totalPosts) {
                this.hideLoadMoreButton();
            }
        } else {
            this.updateButtonState(true);
        }
    },

    handleError(error) {
        console.error('Error loading posts:', error);
        $(".js-load-more").addClass("error");
        setTimeout(() => {
            $(".js-load-more").removeClass("error");
        }, 2000);
    },

    updateButtonState(disabled) {
        $(".js-load-more")
            .attr("disabled", disabled)
            .toggleClass("loading", this.isLoading);
    },

    hideLoadMoreButton() {
        $(".js-load-more").addClass("disabled").hide();
    },

    checkForMorePosts() {
        // Get total posts count from the initial query
        if (!this.totalPosts) {
            this.totalPosts = parseInt($('.js-load-more').data('total-posts') || 0);
        }
        
        // Check if we've loaded all posts
        const loadedPosts = $("#load-more_wrap .post-looper_item").length;
        if (this.totalPosts > 0 && loadedPosts >= this.totalPosts) {
            this.hideLoadMoreButton();
        }
    }
};

export default PostLooper; 